import Axios from "../../api/Axios";
const BASE_URL = "helpdesk/SurveyFeeback/";

export const EndpointSurveyFeedback = {
    LoadSurveryDeatilsByDate: "LoadSurveryDeatilsByDate",
    SaveFeedbackAnsDeails: "SaveFeedbackAnsDeails",
    LoadSurveryDeatilsByID: "LoadSurveryDeatilsByID"
};

export const createAPIEndpointSurveyFeedback = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
